import * as React from 'react'
import Layout from '../components/Layout'
import Snippet from '../components/Snippet'
import Header from '../components/Header'
import styled from 'styled-components'
import { yPad, xPad } from '../utils/theme'
import Card from '../components/CTACard'
import { graphql, Link } from 'gatsby'
import { Button } from '../components/Button'
import { Helmet } from 'react-helmet'

const Column = styled.div`
  width: 100% !important;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-bottom: 1rem;

  @media (min-width: 940px) {
    width: 66.66667% !important;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-bottom: 2rem;
  }
`

const Sidebar = styled.div`
  display: block;
  width: 100%;

  @media (min-width: 940px) {
    width: 33.33333%;
  }

  /* sticky parent must be display: block */
  > div {
    position: sticky;
    top: 2rem;
  }
`

const Container = styled.div`
  width: 100%;
  position: relative;
  max-width: 1220px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  ${yPad};
  ${xPad};

  padding-top: 0 !important;
`

/* prettier-ignore */
interface IProps {
  data: {
    allMarkdownRemark: {
      edges: Array<{
        node: {
          excerpt: string;
          frontmatter: {
            date: string;
            path: string;
            title: string;
            image: {
              childImageSharp: {
                fluid: object;
              };
            };
          };
        };
      }>;
    };
  }
}

export default ({ data }: IProps) => (
  <Layout bg="#f1f8fe">
    <Helmet>
      <title>Blog - Digital Growth Articles - Turboclicks</title>
      <meta
        name="description"
        content="Get access to modern resources on strategy, systems, growth and of course digital marketing from the ones who know it best."
      />
    </Helmet>
    <Header />
    <Container>
      <Column>
        {data.allMarkdownRemark.edges.map(({ node }) => (
          <Snippet data={node} />
        ))}
      </Column>
      <Sidebar>
        <div>
          <Card title="Contact">
            <p>
              Contact us today to get a free personal digital growth strategy
              consultation for your business.
            </p>
            <Link to="/contact">
              <Button inverted={true} full={true}>
                Let's chat
              </Button>
            </Link>
          </Card>
          <Card title="About Turboclicks">
            <p>
              Turboclicks is a digital growth and marketing company located in
              Brisbane, Australia. We offer SEO, PPC, Social Media and Web
              Development to help you grow and develop your business the modern
              way.
            </p>
          </Card>
        </div>
      </Sidebar>
    </Container>
  </Layout>
)

export const pageQuery = graphql`
  query BlogQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
            image {
              childImageSharp {
                fluid(maxWidth: 1000) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            path
          }
        }
      }
    }
  }
`
